// Statistics.js - Version avec design épuré (garder la même structure)
import React, { useMemo } from 'react';
import { 
  FaUniversity,
  FaHome,
  FaUserGraduate,
  FaCheckCircle,
  FaBuilding,
  FaUsers
} from 'react-icons/fa';
import './Statistics.css';
import statsImage from '../../assets/images/3613057_40285-removebg-preview.png';

const Statistics = () => {
  const statsData = useMemo(() => [
    {
      id: 1,
      number: "60",
      title: "Universités françaises partenaires",
      icon: <FaUniversity />,
      color: "#1e3c72"
    },
    {
      id: 2,
      number: "160",
      title: "Résidences étudiantes françaises partenaires",
      icon: <FaHome />,
      color: "#2a5298"
    },
    {
      id: 3,
      number: "+5000",
      title: "Étudiants accompagnés",
      icon: <FaUserGraduate />,
      color: "#dc143c"
    },
    {
      id: 4,
      number: "74%",
      title: "Taux de réussite au visa",
      subtitle: "soit 3/4",
      icon: <FaCheckCircle />,
      color: "#1e3c72"
    },
    {
      id: 5,
      number: "+35",
      title: "Entreprises françaises partenaires",
      icon: <FaBuilding />,
      color: "#2a5298"
    },
    {
      id: 6,
      number: "+60 000",
      title: "Abonnés sur les réseaux sociaux",
      icon: <FaUsers />,
      color: "#dc143c"
    }
  ], []);

  return (
    <section className="stats-section" id="statistics">
      <div className="stats-bg-pattern"></div>
      
      <div className="stats-wrapper">
        <div className="stats-header">
          <div className="title-container">
            <h2 className="stats-main-title">L'ETEF en chiffres</h2>
            <div className="title-underline"></div>
          </div>
          <p className="stats-intro">
            Des résultats qui témoignent de notre expertise et de notre engagement
          </p>
        </div>

        <div className="stats-cards-grid">
          {statsData.map((stat, index) => (
            <div 
              className="stats-item-card" 
              key={stat.id}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="card-icon-container">
                <div className="card-icon">
                  {stat.icon}
                </div>
              </div>
              
              <div className="card-content">
                <div className="number-display">
                  <h3 className="card-number">{stat.number}</h3>
                </div>
                <p className="card-label">{stat.title}</p>
                {stat.subtitle && (
                  <p className="card-sub-label">{stat.subtitle}</p>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="stats-description-box">
          <div className="description-text">
            <h3 className="text-title">
              Un Pont vers l'excellence académique
            </h3>
            <p className="text-content">
              ETEF joue un rôle crucial en connectant les étudiants africains et les institutions 
              académiques de leur région aux opportunités éducatives en France. Notre soutien 
              personnalisé aux étudiants africains souhaitant étudier en France s'accompagne de 
              notre assistance aux établissements africains pour élargir leurs offres et établir 
              des partenariats avec des écoles françaises.
            </p>
          </div>
          
          <div className="description-image-box">
            <div className="image-wrapper">
              <img 
                src={statsImage} 
                alt="Étudiants en apprentissage" 
                className="stats-image"
                loading="lazy"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `
                    <div class="image-fallback">
                      <div style="text-align: center; color: white; padding: 2rem;">
                        <div style="font-size: 3rem; margin-bottom: 1rem;">📊</div>
                        <h3 style="margin: 0 0 0.5rem 0; font-size: 1.5rem;">Statistiques</h3>
                        <p style="margin: 0; opacity: 0.9;">L'ETEF en chiffres</p>
                      </div>
                    </div>
                  `;
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Statistics;